import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Phone, Instagram, Facebook, X } from "lucide-react";
import usePageMeta from "./hooks/usePageMeta";

function Home() {
  usePageMeta("Pavan e Parazzi", "pp");
  
  const [currentSlide, setCurrentSlide] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const slides = [
    {
      title: "AP – Finanças Pessoais",
      description: "Organize suas finanças com facilidade. Controle gastos, investimentos, metas e economias.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxmaW5hbmNlJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc2Mjk0OTM1MHww&ixlib=rb-4.1.0&q=85",
      color: "from-green-900/90 to-green-700/90"
    },
    {
      title: "Flavor",
      description: "Solução completa para gestão de negócios online. Perfeito para confeitarias, pizzarias e lanchonetes.",
      image: "https://images.unsplash.com/photo-1728044849280-10a1a75cff83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwbWFuYWdlbWVudHxlbnwwfHx8fDE3NjI5NDkzNTl8MA&ixlib=rb-4.1.0&q=85",
      color: "from-orange-900/90 to-orange-700/90"
    },
    {
      title: "Igreen",
      description: "Economize até 15% na conta de energia. Cashback, sorteios e Igreen Club com benefícios exclusivos.",
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGVuZXJneXxlbnwwfHx8fDE3NjI5NDkzNjl8MA&ixlib=rb-4.1.0&q=85",
      color: "from-yellow-900/90 to-yellow-700/90"
    },
    {
      title: "SAG",
      description: "Espaço gourmet moderno em Capivari-SP, ideal para festas, eventos e confraternizações.",
      image: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxldmVudCUyMHZlbnVlfGVufDB8fHx8MTc2Mjk0OTM3NXww&ixlib=rb-4.1.0&q=85",
      color: "from-blue-900/90 to-blue-700/90"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <nav className="fixed top-0 w-full bg-white shadow-md z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_finance-dash-68/artifacts/7w39hvkz_Logo%20PP%20sem%20fundo.png" 
                alt="Pavan e Parazzi" 
                className="h-16 w-auto"
              />
            </div>
            
            {/* Menu */}
            <div className="hidden md:flex space-x-4">
              <Link 
                to="/login" 
                className="px-6 py-2 rounded-lg text-white font-medium transition-all duration-300 hover:scale-105 shadow-md"
                style={{ backgroundColor: '#004C27' }}
              >
                AP – Finanças Pessoais
              </Link>
              <button 
                className="px-6 py-2 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all duration-300"
              >
                Flavor
              </button>
              <Link 
                to="/igreen"
                className="px-6 py-2 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all duration-300"
              >
                Igreen
              </Link>
              <button 
                className="px-6 py-2 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all duration-300"
              >
                SAG
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-gray-700 hover:text-gray-900 p-2"
              >
                {mobileMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg absolute w-full z-50">
            <div className="px-4 py-4 space-y-3">
              <Link 
                to="/login" 
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full px-6 py-3 rounded-lg text-white font-medium text-center transition-all duration-300 shadow-md"
                style={{ backgroundColor: '#004C27' }}
              >
                AP – Finanças Pessoais
              </Link>
              <button 
                className="block w-full px-6 py-3 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                Flavor
              </button>
              <Link 
                to="/igreen"
                className="block w-full px-6 py-3 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all duration-300 text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Igreen
              </Link>
              <button 
                className="block w-full px-6 py-3 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                SAG
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Spacer for fixed navbar */}
      <div className="h-20"></div>

      {/* Hero Carousel */}
      <div className="relative h-[600px] overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div className="absolute inset-0">
              <img 
                src={slide.image} 
                alt={slide.title}
                className="w-full h-full object-cover"
              />
              <div className={`absolute inset-0 bg-gradient-to-r ${slide.color}`}></div>
            </div>
            
            <div className="relative h-full flex items-center justify-center text-center px-4">
              <div className="max-w-4xl">
                <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 animate-fade-in">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl text-white/90 animate-fade-in">
                  {slide.description}
                </p>
              </div>
            </div>
          </div>
        ))}

        {/* Carousel Controls */}
        <button 
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300"
        >
          <ChevronLeft size={32} />
        </button>
        <button 
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300"
        >
          <ChevronRight size={32} />
        </button>

        {/* Carousel Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-3 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'w-8 bg-white' : 'w-3 bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>

      {/* AP - Finanças Pessoais Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-bold mb-6" style={{ color: '#004C27' }}>
                AP – Finanças Pessoais
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Organize suas finanças com facilidade. Controle gastos, investimentos, metas e economias de forma simples e visual. Ideal para quem quer dominar o próprio dinheiro e realizar objetivos.
              </p>
              <Link 
                to="/login"
                className="inline-block px-8 py-4 rounded-lg text-white font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
                style={{ backgroundColor: '#004C27' }}
              >
                Conheça o AP Finanças
              </Link>
            </div>
            <div className="order-1 md:order-2">
              <img 
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxmaW5hbmNlJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc2Mjk0OTM1MHww&ixlib=rb-4.1.0&q=85" 
                alt="AP Finanças"
                className="rounded-2xl shadow-2xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Flavor Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_d252bcf0-fa70-4731-a84b-2154815486b7/artifacts/po9lzayj_image.png" 
                alt="Flavor"
                className="rounded-2xl shadow-2xl w-full h-auto"
              />
              <div className="absolute top-4 left-4 bg-orange-600/90 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-lg">
                Em Desenvolvimento
              </div>
            </div>
            <div>
              <h2 className="text-4xl font-bold text-orange-600 mb-6">
                Flavor
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Solução completa para gestão de negócios online. Cadastre produtos, gerencie pedidos, acompanhe entregas e estoque — perfeito para confeitarias, pizzarias e lanchonetes que vendem pela internet.
              </p>
              <button 
                className="inline-block px-8 py-4 bg-orange-600 rounded-lg text-white font-semibold transition-all duration-300 hover:bg-orange-700 hover:scale-105 shadow-lg"
              >
                Ver detalhes do Flavor
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Igreen Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-bold text-yellow-600 mb-6">
                Igreen
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Economize até 15% na conta de energia com a Igreen. Além dos descontos, ganhe cashback, participe de sorteios e tenha acesso ao Igreen Club com benefícios exclusivos — tudo sem pagar nada a mais.
              </p>
              <Link 
                to="/igreen"
                className="inline-block px-8 py-4 bg-yellow-600 rounded-lg text-white font-semibold transition-all duration-300 hover:bg-yellow-700 hover:scale-105 shadow-lg"
              >
                Quero economizar com a Igreen
              </Link>
            </div>
            <div className="order-1 md:order-2">
              <img 
                src="https://images.unsplash.com/photo-1558449028-b53a39d100fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxzb2xhciUyMGVuZXJneXxlbnwwfHx8fDE3NjI5NDkzNjl8MA&ixlib=rb-4.1.0&q=85" 
                alt="Igreen"
                className="rounded-2xl shadow-2xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SAG Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="relative rounded-2xl shadow-2xl overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1665607437981-973dcd6a22bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxldmVudCUyMHZlbnVlfGVufDB8fHx8MTc2Mjk0OTM3NXww&ixlib=rb-4.1.0&q=85" 
                  alt="SAG"
                  className="w-full h-auto filter blur-sm brightness-75"
                />
                <div className="absolute inset-0 bg-black/30"></div>
              </div>
              <div className="absolute top-4 left-4 bg-blue-600/90 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-lg z-10">
                Em Construção
              </div>
            </div>
            <div>
              <h2 className="text-4xl font-bold text-blue-600 mb-6">
                SAG
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Espaço gourmet moderno em Capivari-SP, ideal para festas, eventos e confraternizações. Estrutura completa, ambiente agradável e disponível para locação.
              </p>
              <button 
                className="inline-block px-8 py-4 bg-blue-600 rounded-lg text-white font-semibold transition-all duration-300 hover:bg-blue-700 hover:scale-105 shadow-lg"
              >
                Conheça o SAG
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Logo e Descrição */}
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_finance-dash-68/artifacts/7w39hvkz_Logo%20PP%20sem%20fundo.png" 
                alt="Pavan e Parazzi" 
                className="h-16 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-gray-400 text-sm">
                Soluções em tecnologia e serviços integrados para impulsionar seu negócio e vida pessoal.
              </p>
            </div>

            {/* Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Links Úteis</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors">
                    Termos de Uso
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors">
                    Política de Privacidade
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors">
                    Contato
                  </a>
                </li>
              </ul>
            </div>

            {/* Redes Sociais */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Conecte-se</h3>
              <div className="flex space-x-4 mb-4">
                <a 
                  href="https://www.instagram.com/pavaneparazzi" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-pink-600 transition-colors"
                >
                  <Instagram size={24} />
                </a>
                <a 
                  href="https://www.facebook.com/pavaneparazzi" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-blue-600 transition-colors"
                >
                  <Facebook size={24} />
                </a>
                <a 
                  href="https://wa.me/5519920008711" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-green-600 transition-colors"
                >
                  <Phone size={24} />
                </a>
              </div>
              <p className="text-gray-400 text-sm">
                <Phone size={16} className="inline mr-2" />
                (19) 9 2000-8711
              </p>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © 2025 Pavan e Parazzi – Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
